/* ArtMindr — otvaryane na knigata + parvata stranica (stapka 6).
   Pokazva se SAMO kogato: produktat e kniga za chetene I AMFConfig.innerPage === true
   Rabotи zaedno s am-preview.js (UI) i artmindr-preview-connect.js (API). */
(function(){
  'use strict';
  var root = document.querySelector('[data-amf-root]');
  if(!root) return;
  var book    = root.querySelector('[data-amf-book]');
  var btn     = root.querySelector('[data-amf-openbook]');
  var every   = root.querySelector('[data-amf-everypage]');
  var inner   = root.querySelector('[data-amf-book-inner]');
  var loader  = root.querySelector('[data-amf-inner-loader]');
  var statusEl= root.querySelector('[data-amf-inner-status]');
  var failEl  = root.querySelector('[data-amf-inner-fail]');
  var ring    = root.querySelector('[data-amf-ring]');
  var textEl  = root.querySelector('[data-amf-inner-text]');
  var clockEl = root.querySelector('[data-amf-inner-elapsed]');
  var promise = root.querySelector('[data-amf-promise]');
  var dedm    = root.querySelector('[data-amf-dedm]');
  if(!book || !btn) return;

  function innerEnabled(){
    if(!window.AMFConfig || !window.AMFConfig.innerPage) return false;
    return !!(window.amfState && window.amfState.product === 'reading');
  }

  var R = 52, C = 2 * Math.PI * R;
  if(ring){ ring.style.strokeDasharray = C.toFixed(1); ring.style.strokeDashoffset = C.toFixed(1); }

  var TIMEOUT = 180000;

  var opened = false, armed = false, phase = 'idle', currentImage = null, requestId = 0;
  var t0 = 0, clockId = null, pct = 0, timeoutId = null;

  function childName(){ return (window.amfState && window.amfState.name) || 'детето'; }
  function setRing(p){ pct = p; if(ring){ ring.style.strokeDashoffset = (C * (1 - p)).toFixed(1); } }

  /* posvetenieto se personalizira po pol */
  function fillDedication(){
    var g = (window.amfState && window.amfState.gender) === 'момче' ? 'му' : 'ѝ';
    var line = 'Представи си усмивката ' + g + ', когато се види вътре.';
    Array.prototype.slice.call(root.querySelectorAll('[data-amf-ded-line]')).forEach(function(el){ el.textContent = line; });
  }

  function statusFor(ms){
    if(!statusEl) return '';
    return (ms < 120000 ? statusEl.dataset.busyLabel : statusEl.dataset.slowLabel).replace('[name]',childName());
  }

  function stopClock(){
    if(clockId !== null){ clearTimeout(clockId); clockId = null; }
  }

  function tick(){
    stopClock();
    if(phase !== 'loading') return;
    var ms = Math.max(0, Date.now() - t0), seconds = Math.floor(ms / 1000);
    if(clockEl){
      clockEl.textContent = String(Math.floor(seconds / 60)).padStart(2,'0') + ':' + String(seconds % 60).padStart(2,'0');
      clockEl.setAttribute('datetime','PT' + seconds + 'S');
    }
    if(statusEl){ var s = statusFor(ms); if(statusEl.textContent !== s) statusEl.textContent = s; }
    if(!document.hidden) clockId = setTimeout(tick,1000);
  }
  document.addEventListener('visibilitychange',function(){ if(document.hidden) stopClock(); else if(phase === 'loading') tick(); });
  window.addEventListener('pagehide',stopClock);
  window.addEventListener('pageshow',function(){ if(phase === 'loading') tick(); });

  function ringToFull(cb){
    stopClock();
    if(!ring || matchMedia('(prefers-reduced-motion: reduce)').matches){ if(cb) cb(); return; }
    var from = pct, start = Date.now(), dur = 450;
    (function anim(){
      var k = Math.min(1, (Date.now() - start) / dur);
      setRing(from + (1 - from) * k);
      if(k < 1){ requestAnimationFrame(anim); } else if(cb){ cb(); }
    })();
  }

  function showPage(d, ticket){
    var img = new Image();
    img.className = 'am-book-innerimg';
    img.alt = 'Първата страница';
    img.onload = function(){
      if(ticket !== requestId || phase !== 'loading') return;
      clearTimeout(timeoutId);
      phase = 'ready';
      stopClock();
      ringToFull(function(){
        if(ticket !== requestId) return;
        if(loader) loader.style.display = 'none';
        if(ticket !== requestId) return;
        if(inner){ inner.querySelectorAll('.am-book-innerimg').forEach(function(old){old.remove();}); inner.appendChild(img); }
        if(every) every.classList.add('is-on');
        if(textEl && d && d.inner_text){ textEl.textContent = d.inner_text; textEl.classList.add('is-on'); }
        syncBookButton();
        btn.setAttribute('data-amf-mode', 'toggle');
        btn.disabled = false;
        root.dispatchEvent(new CustomEvent('amf:innerready'));
      });
    };
    img.onerror = function(){ if(ticket === requestId) failInner(); };
    img.src = d.inner_url;
  }

  function failInner(){
    if(phase === 'ready') return;
    phase = 'failed';
    clearTimeout(timeoutId);
    stopClock();
    if(loader) loader.style.display = 'none';
    if(failEl) failEl.style.display = 'block';
    btn.textContent = 'Опитай отново';
    btn.removeAttribute('data-amf-mode');
    btn.disabled = false;
  }

  function startInner(){
    if(phase === 'loading' || phase === 'ready') return;
    phase = 'loading';
    var ticket = ++requestId;
    if(failEl) failEl.style.display = 'none';
    if(loader) loader.style.display = 'flex';
    setRing(0);
    t0 = Date.now();
    if(statusEl) statusEl.textContent = statusFor(0);
    tick();
    btn.disabled = true;
    if(timeoutId) clearTimeout(timeoutId);
    timeoutId = setTimeout(function(){ if(ticket === requestId && phase === 'loading'){ failInner(); } }, TIMEOUT);

    var p;
    if(typeof window.amfGenerateInner === 'function'){ p = window.amfGenerateInner(window.amfState); }
    else { p = Promise.reject(new Error('no connector')); }
    p.then(function(d){
      if(ticket !== requestId || phase !== 'loading') return;
      if(!d || !d.inner_url){ failInner(); return; }
      showPage(d, ticket);
    }).catch(function(e){
      console.warn(e && e.message ? e.message : e);
      if(ticket !== requestId || phase !== 'loading') return;
      clearTimeout(timeoutId);
      failInner();
    });
  }

  function openBook(){
    if(!innerEnabled()) return;
    if(!opened){
      opened = true;
      fillDedication();
      book.classList.add('is-open');
      if(dedm) dedm.classList.add('is-on');
      if(typeof window.amfDelaySticky === 'function'){ window.amfDelaySticky(10000); }
    }
    if(phase === 'idle' || phase === 'failed'){ startInner(); }
  }

  function syncBookButton(){
    var isOpen = book.classList.contains('is-open');
    btn.textContent = isOpen ? btn.dataset.closeLabel : btn.dataset.openLabel;
    btn.setAttribute('aria-expanded', String(isOpen));
  }

  btn.addEventListener('click', function(){
    if(btn.getAttribute('data-amf-mode') === 'toggle'){
      book.classList.toggle('is-open');
      syncBookButton();
      return;
    }
    openBook();
  });

  book.addEventListener('click', function(){
    if(!innerEnabled()) return;
    if(!opened){ openBook(); return; }
    book.classList.toggle('is-open');
    if(phase === 'ready') syncBookButton();
  });

  function arm(){
    if(armed) return;
    armed = true;
    fillDedication();
    if(promise && window.amfState && window.amfState.product === 'poster'){
      promise.textContent = '✓ Получаваш точно този плакат — това е файлът за печат.';
    }
    if(!innerEnabled()){ btn.style.display = 'none'; return; }
    btn.style.display = '';
    btn.classList.add('is-ready');
    btn.setAttribute('aria-expanded','false');
  }
  function syncCover(){
    var image = book.querySelector('.am-preview-book-face--front img');
    if(!image || image === currentImage) return;
    currentImage = image;
    requestId++;
    clearTimeout(timeoutId);
    stopClock();
    opened = false; armed = false; phase = 'idle';
    book.classList.remove('is-open');
    if(inner) inner.querySelectorAll('.am-book-innerimg').forEach(function(old){old.remove();});
    if(loader) loader.style.display = 'none';
    if(failEl) failEl.style.display = 'none';
    if(every) every.classList.remove('is-on');
    if(dedm) dedm.classList.remove('is-on');
    if(textEl){ textEl.classList.remove('is-on'); textEl.textContent = ''; }
    btn.removeAttribute('data-amf-mode');
    btn.disabled = false;
    btn.textContent = btn.dataset.openLabel;
    setRing(0);
    arm();
    var announced = false;
    function arrived(){
      if(announced || currentImage !== image || !image.naturalWidth) return;
      announced = true;
      root.dispatchEvent(new CustomEvent('amf:covermounted',{bubbles:true}));
    }
    if(image.complete) requestAnimationFrame(arrived);
    else image.addEventListener('load',arrived,{once:true});
  }
  root.addEventListener('amf:coverchange',syncCover);
  root.addEventListener('amf:stepchange',function(event){
    if(event.detail.step === 5){requestId++;clearTimeout(timeoutId);stopClock();phase = 'idle';}
  });
  var obs = new MutationObserver(syncCover);
  obs.observe(book, { childList:true, subtree:true });
  syncCover();
})();
